import { ALLIANCE_APPS } from './alliance-apps';

/**
 * This repo's app: the per-app values the shared Alliance components read.
 */
export const CURRENT_APP = ALLIANCE_APPS.university;

/**
 * Display fonts. Roboto is used everywhere else. The nav font applies to the
 * top-nav links and the wordmark; the title font to Sign In and System
 * Screen headings.
 */
export const CURRENT_APP_FONTS = {
  nav: {
    fontFamily: "'Bebas Neue', sans-serif",
    fontWeight: 400,
    textTransform: 'uppercase',
  },
  // The app name beside the Alliance logo (design: 24px, 85% on phones)
  brand: {
    fontSize: 24,
    fontSizeCompact: 20,
    letterSpacing: '.06em',
  },
  title: {
    fontFamily: "'Bebas Neue', sans-serif",
    fontWeight: 400,
    textTransform: 'uppercase',
  },
} as const;
